module.exports = __webpack_public_path__ + "static/img/brees-2013-slide-5.ac7879b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-slide-5.jpg
// module id = h2kI
// module chunks = 1